export const brandCodes = [
  "speedyglass",
  "cre",
  "fixaut",
  "novusglass",
  "proc",
  "speedyauto",
] as const;

export type BrandCode = (typeof brandCodes)[number];

export const regionCodes = ["ca", "us", "mx", "nz", "de", "au"] as const;

export type RegionCode = (typeof regionCodes)[number];

export const brandRegionCodes = [
  "creca",
  "fixautau",
  "fixautca",
  "fixautde",
  "fixautmx",
  "novusglassau",
  "novusglassca",
  "novusglassus",
  "procca",
  "procus",
  "speedyautoca",
  "speedyglassus",
] as const;

export type BrandRegionCode = (typeof brandRegionCodes)[number];

export const brandRegionCodeRegionMap: Record<BrandRegionCode, RegionCode> = {
  speedyglassus: "us",
  creca: "ca",
  fixautau: "au",
  fixautca: "ca",
  fixautmx: "mx",
  fixautde: "de",
  novusglassau: "au",
  novusglassca: "ca",
  novusglassus: "us",
  procca: "ca",
  procus: "us",
  speedyautoca: "ca",
} as const;
